import classNames from 'classnames'
import React from 'react'

interface BulletinWrapperProps {
  children: React.ReactNode
  className?: string
}

export const BulletinWrapper: React.FC<BulletinWrapperProps> = ({
  children,
  className,
}) => {
  return (
    <div className={classNames('flex flex-col items-start', className)}>
      {children}
    </div>
  )
}
